import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Modal from "../UI/Modal";
import Alert from "../UI/Alert";
import Loader from "../UI/Loader";
import { Icon } from "@iconify/react";
import {
  createPhraseByPlantelThunk,
  getFrasesByPlantelThunk,
  getTalentsSelectorByPlantelThunk,
} from "../../store/reducers/plantels/plantels.thunks";
import { toast } from "react-toastify";
import { closePhraseForm } from "../../store/reducers/plantels/phrasesByPlantel.reducer";

const PhraseByPlantelFormModal = ({ plantelId }) => {
  const dispatch = useDispatch();

  const { formModalOpen, formLoading, formError } = useSelector(
    (state) => state.frasesByPlantel,
  );

  const { list: talentosSelector } = useSelector(
    (state) => state.talentsSelector || { list: [] },
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (formModalOpen && plantelId) {
      dispatch(getTalentsSelectorByPlantelThunk(plantelId));
    }
  }, [formModalOpen, plantelId, dispatch]);

  const handleClose = () => {
    reset();
    dispatch(closePhraseForm());
  };

  const onSubmit = async (data) => {
    const payload = {
      frase: data.frase,
      talento_plantel: data.talento_plantel || null,
      plantel: plantelId,
    };

    const result = await dispatch(createPhraseByPlantelThunk(payload));

    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Frase creada correctamente");

      handleClose();

      //refresca lista automáticamente
      dispatch(
        getFrasesByPlantelThunk({
          plantelId,
          talentoPlantelId: null,
          page: 1,
        }),
      );
    }
  };

  return (
    <Modal
      open={formModalOpen}
      title="Nueva frase"
      size="lg"
      onClose={handleClose}
    >
      {formError && <Alert type="danger" message={formError} />}

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row g-3">
          <div className="col-12">
            <label className="form-label">
              Frase <span className="text-danger">*</span>
            </label>
            <textarea
              rows={3}
              className={`form-control ${errors.frase ? "is-invalid" : ""}`}
              {...register("frase", { required: "La frase es requerida" })}
            />
          </div>

          <div className="col-12">
            <label className="form-label">Talento asociado (opcional)</label>
            <select className="form-select" {...register("talento_plantel")}>
              <option value="">Sin talento</option>
              {talentosSelector?.map((talento) => (
                <option key={talento.id} value={talento.id}>
                  {talento.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={formLoading}
          >
            Cancelar
          </button>

          <button
            type="submit"
            className="btn btn-primary d-flex align-items-center gap-2"
            disabled={formLoading}
          >
            {formLoading ? (
              <Loader type="spinner" text="Guardando..." size="sm" delay={0} />
            ) : (
              <>
                <Icon icon="mdi:content-save" width="20" />
                Crear
              </>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default PhraseByPlantelFormModal;
